export default [
  {
    id: 'simple',
    name: 'Timer',
    description: 'A circular timer with instructive icons',
  },
  {
    id: 'expandingParticles',
    name: 'Dreamy bubbles',
    description: 'An expanding and contracting circle of random bubbles',
  }
];
